module.exports = __webpack_public_path__ + "img/2-Girls.a09aba96.jpg";